import { action, observable } from 'mobx';

class Cookie {
    @observable viewed = true;
    @observable contentAnchor = null;

    localStorageName = 'viewed';

    @action
    populate = () => {
      this.viewed = localStorage.getItem(this.localStorageName) === "true" ? true : false
      document.body.style.paddingBottom = this.viewed ? '' : window.getComputedStyle(this.contentAnchor, null).getPropertyValue('height')
    }

// Function from David Walsh: http://davidwalsh.name/css-animation-callback
 whichTransitionEvent = () => {
  var t,
      el = document.createElement("fakeelement");

  var transitions = {
    "transition"      : "transitionend",
    "OTransition"     : "oTransitionEnd",
    "MozTransition"   : "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (t in transitions){
    if (el.style[t] !== undefined){
      return transitions[t];
    }
  }
}


destroyCookieNotification = (event) => {
  const transitionEvent = this.whichTransitionEvent();
  this.contentAnchor.removeEventListener(transitionEvent, this.destroyCookieNotification);
  // this.contentAnchor.remove()
}

closeCookieNotification = ( event ) => {
  const transitionEvent = this.whichTransitionEvent();
  localStorage.setItem(this.localStorageName, true)
  this.contentAnchor.dataset.active = false
  document.body.style.paddingBottom = ''
  this.contentAnchor.addEventListener(transitionEvent, this.destroyCookieNotification);
}
}
const CookieStore = new Cookie();
export default CookieStore;
